import {useMemo} from "react";
import clsx, {ClassValue} from "clsx";

export function useCLSX(...args: ClassValue[]) {

    return useMemo(() => {
        return clsx(...args);
    }, [args])

}